
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2041"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2041"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("27Lyk", function(module, exports) {

$parcel$export(module.exports, "register", () => $18c11f3350a906ea$export$6503ec6e8aabbaf, (v) => $18c11f3350a906ea$export$6503ec6e8aabbaf = v);
var $18c11f3350a906ea$export$6503ec6e8aabbaf;
var $18c11f3350a906ea$export$f7ad0328861e2f03;
"use strict";
var $18c11f3350a906ea$var$mapping = new Map();
function $18c11f3350a906ea$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$18c11f3350a906ea$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $18c11f3350a906ea$var$resolve(id) {
    var resolved = $18c11f3350a906ea$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$18c11f3350a906ea$export$6503ec6e8aabbaf = $18c11f3350a906ea$var$register;
$18c11f3350a906ea$export$f7ad0328861e2f03 = $18c11f3350a906ea$var$resolve;

});

var $7f856ef58ef80c33$exports = {};

(parcelRequire("27Lyk")).register(new URL("", import.meta.url).toString(), JSON.parse('["auyDg","index.64657665.js","5U355","smallStar.acdc2e92.svg","3A8EL","gitpurple.abcca67b.svg","WRKDL","demo.ba9c5950.svg"]'));

var $49690c6d385a05bd$exports = {};
$49690c6d385a05bd$exports = new URL("smallStar.acdc2e92.svg", import.meta.url).toString();


var $d2d81ecc0736b403$exports = {};
$d2d81ecc0736b403$exports = new URL("gitpurple.abcca67b.svg", import.meta.url).toString();


var $1217f1aea9c72452$exports = {};
$1217f1aea9c72452$exports = new URL("demo.ba9c5950.svg", import.meta.url).toString();


console.log("If you like this page - send me a massage: grudzinski.business@gmail.com");
const $2b6e161c9edcf319$var$username = "kacper-grudzinski";
const $2b6e161c9edcf319$var$direction = "desc";
const $2b6e161c9edcf319$var$projectsContainer = document.querySelector(".projects--js");
fetch(`https://api.github.com/users/${$2b6e161c9edcf319$var$username}/repos?direction=${$2b6e161c9edcf319$var$direction}`).then((response)=>response.json()).then((response)=>{
    for (let repository of response){
        const { homepage: homepage, topics: topics, stargazers_count: stargazers_count, description: description, name: name, html_url: html_url } = repository;
        let tags = ``;
        for (let tag of topics)tags += `<li class="rounded bg-gray-400/10 py-1 px-2 text-sm font-bold">${tag}<li/>`;
        const element = `<article
        class="rounded-wtf md:rounded-wtf-xl overflow-clip bg-gradient-to-br from-white/10 to-white/5 flex flex-col h-full"
      >
        <div
          class="flex ring-1 ring-inset ring-bg shadow-innerlight rounded-t-wtf md:rounded-t-wtf-xl gap-1.5 p-4 bg-gradient-to-br from-white/10 to-white/5 h-11"
        >
          <span
            class="hover:bg-red-600 h-3 w-3 block rounded-full bg-bg opacity-50"
          ></span>
          <span class="h-3 w-3 block rounded-full bg-bg opacity-50"></span>
          <span
            class="h-3 hover:bg-orange-400 w-3 block rounded-full bg-bg opacity-50"
          ></span>
        </div>
        <div
          class="p-5 md:p-6 lg:p-10 flex flex-col justify-between grow ring-1 ring-inset ring-bg"
        >
          <div>
            <header class="items-center mb-4 flex gap-4">
              <h3 class="font-bold leading-none text-2xl">${name}</h3>
              <p
                class="flex rounded leading-none items-center gap-0.5 bg-gray-400/10 py-1 px-2 text-gray-400 font-medium"
              >
                <img
                  src="${(0, (/*@__PURE__*/$parcel$interopDefault($49690c6d385a05bd$exports)))}"
                  alt=""
                  class="w-4 h-4"
                />${stargazers_count}
              </p>
            </header>

            <p class="text-gray-400 text-xl mb-4">${description}</p>
            <ul class="flex gap-2 mb-10 flex-wrap">
              ${tags}
            </ul>
          </div>
          <div
            class="flex flex-col flex-wrap md:flex-row gap-4 items-start"
          >
            <a
              target="_blank"
              rel="noreferrer nofollow"
              class="text-accent bg-bg flex gap-3 font-bold py-4 px-5 items-center rounded-xl border-lightGray border-2 md:text-xl hover:border-accent-500 hover:text-accent-500 transition-all duration-150"
              href="${homepage}"
              ><img
                src="${(0, (/*@__PURE__*/$parcel$interopDefault($1217f1aea9c72452$exports)))}"
                alt=""
                class="w-6 h-6"
                height="24"
                width="24"
              />View demo</a
            >
            <a
              target="_blank"
              rel="noreferrer nofollow"
              class="text-accent bg-bg flex gap-3 font-bold py-4 px-5 items-center rounded-xl border-lightGray border-2 md:text-xl hover:border-accent-500 hover:text-accent-500 transition-all duration-150"
              href="${html_url}"
              ><img src="${(0, (/*@__PURE__*/$parcel$interopDefault($d2d81ecc0736b403$exports)))}" alt="" />Source code</a
            >
          </div>
        </div>
      </article>`;
        if (homepage && stargazers_count > 0) $2b6e161c9edcf319$var$projectsContainer.insertAdjacentHTML("beforeend", element);
    }
}).catch((e)=>console.log(e));


//# sourceMappingURL=index.64657665.js.map
